var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("signature-hub", {
        attrs: {
          "cancel-document": _vm.cancelDocument,
          participants: _vm.participants,
          "print-action-text": _vm.getNameButtonPrint,
          "related-id": _vm.relatedId,
          "resend-invitation": _vm.resendInvitation,
          "save-signature-hub": _vm.saveSignatureHub,
          "search-user-email": _vm.searchUserEmail,
          "send-document": _vm.sendDocument,
          "signature-hub-info": _vm.signatureHubInfo,
          "type-id": _vm.typeId,
          "user-profile-info": _vm.userProfileInfo
        },
        on: {
          "document-cancelled": _vm.handleDocumentCancelled,
          "go-back": _vm.handleGoBack,
          print: _vm.handlePrint,
          saved: _vm.handleSaved,
          "update-signature": _vm.handleUpdateSignature
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }